import React from 'react'

function Cancel() {
  return (
    <div>
      Cancel
Cancel
    </div>
  )
}

export default Cancel
